import { jsx as _jsx } from "react/jsx-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useOverlayContext } from 'seagull';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { makeFailure, makeSuccess, sendErrReport } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
import { NameThisDocumentModal, NameThisDocumentModalError } from '../NameThisDocumentModal/NameThisDocumentModal';
export const useRenameLegalTerms = (param)=>{
    let { errorToastTestId } = param;
    const { t: legalTexts } = useLocaleKeys('components.legalTermsDropdown');
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { showModal, showErrorToast } = useOverlayContext();
    const { RICH_TEXT_LEGAL_TERMS = false } = useFeatureFlags();
    const { mutateAsync: renameLegalTerms, isPending } = useMutationState({
        mutationFn: async (param)=>{
            let { legalTermsId, newName } = param;
            try {
                RICH_TEXT_LEGAL_TERMS ? await api.business.renameLegalTerms(legalTermsId, newName) : await api.business.renameLegalTermsOld(legalTermsId, newName);
                return makeSuccess(undefined);
            } catch (error) {
                var _error_response;
                if (error instanceof AxiosError && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 400 && NameThisDocumentModalError[error.response.data.error]) {
                    return makeFailure(error.response.data.error);
                }
                return makeFailure(error);
            }
        },
        onSettled: (result)=>{
            if (result === null || result === void 0 ? void 0 : result.success) {
                queryClient.invalidateQueries({
                    queryKey: [
                        QueryKeys.LegalTerms
                    ]
                });
            } else {
                if (!NameThisDocumentModalError[result === null || result === void 0 ? void 0 : result.error]) {
                    const message = legalTexts.unknownError();
                    sendErrReport(result === null || result === void 0 ? void 0 : result.error);
                    showErrorToast(message, errorToastTestId);
                }
            }
        }
    });
    const onRenameLegalTerm = async (legalTerms)=>{
        await showModal({
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(NameThisDocumentModal, {
                    currentFileName: legalTerms.name,
                    currentLegalTermsId: legalTerms.id,
                    onConfirm: (newName)=>renameLegalTerms({
                            legalTermsId: legalTerms.id,
                            newName
                        }),
                    dismissModal: dismissModal
                });
            }
        });
    };
    return {
        renameLegalTerms: onRenameLegalTerm,
        isPending
    };
};
